/**
 * Creates a user name using the information provided in the uploaded csv
 * @param {object} record a row of data from the parsed csv 
 * @returns {string} the new username
 */
export default function makeBackupUsername(record) {
  const { First, Last, MI, Month1, Month2, Day1, Day2 } = record
  let backupUsername = `${First}${MI}${Last}${Month1}${Month2}${Day1}${Day2}`
  backupUsername = backupUsername.toLowerCase()
  backupUsername = backupUsername.replace(/\s+/g, '')
  return backupUsername
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/makeBackupUsername.js